import { getLedgerEntries } from '../../api/billingApi';

const PAGE_SIZE = 500;
const MAX_PAGES = 10;

/**
 * Credits per run (workflow id) from the billing ledger, or null when the
 * figures can't be complete: no org, an error, or more than 10 pages.
 */
export async function fetchCreditsByRun({ orgId, from, to }) {
  if (!orgId) return null;
  try {
    const totals = {};
    for (let page = 1; page <= MAX_PAGES; page += 1) {
      const res = await getLedgerEntries({ orgId, from, to, page, pageSize: PAGE_SIZE });
      (res.items || []).forEach((it) => {
        if (!it.run_id) return;
        totals[it.run_id] = (totals[it.run_id] || 0) + (Number(it.total_cost_credits) || 0);
      });
      if (page >= (res.pages || 1)) return totals;
    }
    return null;
  } catch {
    return null;
  }
}
